'use strict';

function PerformanceReviewInviteController(salaryService, $location, $modal, $filter, $timepicker, $datepicker, performanceReviewService, $log) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.setEmail = setEmail;
  vm.postInvite = postInvite;
  vm.postInvitations = postInvitations;
  vm.postEditedPendingInvite = postEditedPendingInvite;
  vm.postEditedOngoingInvite = postEditedOngoingInvite;
  vm.postResendInvite = postResendInvite;
  vm._requestAll = _requestAll;
  vm._refreshAll = _refreshAll;
  vm._refreshInvites = _refreshInvites;
  vm._refreshInvited = _refreshInvited;
  vm.deleteInvite = deleteInvite;
  vm.basisExists = basisExists;
  vm.selectIndividualBasis = selectIndividualBasis;
  vm.updateInvites = updateInvites;

  vm.hasInvites = hasInvites;
  vm.hasInvited = hasInvited;
  vm.timepickerFormat = $timepicker.defaults.timeFormat;
  vm.datepickerFormat = $datepicker.defaults.dateFormat;
  vm.rounds = [];

  function $onInit() {
    vm._refreshAll({ data: vm.data });
    vm.location = $location.path();
    updateInvites();
  }

  function updateInvites() {
    vm.invites.forEach(function(invite) {
      invite.canBeDeleted = true;
    });
  }

  function setEmail(email) {
    vm.email = email;
  }

  function postInvite(invite) {
    return salaryService.create
      .invite(vm.round, invite.first_name, invite.last_name, invite.email, invite.transpire)
      .then(vm._requestAll)
      .catch(function (response) {
        var message = 'invite.conflict.duplicate';
        if (response.data.error === 'Invalid manager') {
          message = 'invite.conflict.taken';
        }

        var modal = $modal({template: require('./salary-invite.modal.user-conflict.html'), show: true});
        modal.$scope.errorMessage = message;
      });
  }

  function postInvitations() {
    return salaryService.create
      .inviteTokens(vm.round, vm.email.subject, vm.email.message, vm.email.signature)
      .then(vm._refreshInvited)
      .then(vm._refreshInvites);
  }

  function postEditedPendingInvite(index, invite) {
    return postEditedInvite(invite, false);
  }

  function postEditedOngoingInvite(index, invite) {
    return postEditedInvite(invite, true);
  }

  function postEditedInvite(invite, isOngoingInvite) {
    var modal = $modal({ template: require('./salary-invite.modal.edit.html'), show: true });

    modal.$scope.data = invite;

    var subject = $filter('translate')('standard_invite_email_title');
    var body = $filter('translate')('standard_invite_email_content');
    var signature = $filter('translate')('standard_invite_email_signature', {
      first_name: vm.me.first_name,
      last_name: vm.me.last_name
    });

    modal.$scope.reset  = modal.$scope.$hide;
    modal.$scope.submit = function(edited) {
      var promise = salaryService
        .update
        .invite(invite.id, edited.first_name, edited.last_name, edited.transpire, subject, body, signature, edited.assessment_round_connection, edited.email);

      if (isOngoingInvite) {
        promise.then(_showEmailSentModal);
      }

      return promise
        .then(vm._requestAll)
        .finally(modal.$scope.$hide);
    };
  }

  function _showEmailSentModal(response) {
    $modal({ template: require('./salary-invite.modal.mail-sent.html'), show: true });
    return response;
  }

  function postResendInvite(index, invite) {
    var modal = $modal({ template: require('./salary-invite.modal.email.html'), show: true });

    modal.$scope.me = vm.me;
    modal.$scope.reset = modal.$scope.$hide;
    modal.$scope.submit = function(mail) {
      return salaryService.util
        .inviteResend(invite.id, mail.subject, mail.message, mail.signature)
        .then(_showEmailSentModal)
        .finally(modal.$scope.$hide);
    };
  }

  function _requestAll() {
    salaryService.list
      .invite(vm.round)
      .then(vm._refreshInvites)
      .then(vm._refreshInvited);
  }

  function _refreshAll(response) {
    vm._refreshInvites(response);
    vm._refreshInvited(response);
    return response;
  }

  function _refreshInvites(response) {
    vm.invites = response.data.invites;
    updateInvites();
    return response;
  }

  function _refreshInvited(response) {
    vm.invited = response.data.invited;
    vm.invited.forEach(function(invited) {
      performanceReviewService.list.roundsByInvitedUser(invited.user).then(function(result) {
        invited.assessment_rounds = result.data;
      });
    });
    return response;
  }

  function basisExists(assessment_round, assessment_rounds) {
    if(angular.isDefined(assessment_rounds)) {
      for (var i = 0; i < assessment_rounds.length; i++) {
        if(assessment_rounds[i].id === assessment_round) {
          return true;
        }
      }
      return false;
    }
  }

  function hasInvites() {
    return (vm.invites.length || []) > 0;
  }

  function hasInvited() {
    return (vm.invited.length || []) > 0;
  }

  function deleteInvite(index, invite) {
    salaryService.delete
      .invite(invite.id)
      .then(vm._requestAll);
  }

  function selectIndividualBasis(invited) {
    $log.log(invited.assessment_round_connection);
    salaryService.update.invite(
        invited.id,
        invited.first_name,
        invited.last_name,
        invited.transpire,
        null,
        null,
        null,
        invited.assessment_round_connection);
  }
}

module.exports = PerformanceReviewInviteController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-invite/salary-invite/salary-invite.controller.js
 ** module id = 196
 ** module chunks = 0
 **/